import { PALLET_LENGTH_IN_CENTIMETER, PALLET_MIN_WIDTH_IN_CENTIMETER } from 'constants/pallet'
import { Decorator } from 'final-form'
import createDecorator from 'final-form-calculate'
import get from 'lodash/get'
import { OrderCargoServiceType } from 'schema'

import { createTerminalSyncDecorators, resetTerminalSyncState, TerminalSyncState } from '../../helpers/decorator'
import { OrderGuestCreateFormData } from '../../pages/OrderGuestCreatePage/types'

const departureTerminalState: TerminalSyncState = {
  lastOperations: undefined,
  lastTerminalId: undefined
}

const destinationTerminalState: TerminalSyncState = {
  lastOperations: undefined,
  lastTerminalId: undefined
}

export function resetTerminalSyncStates() {
  resetTerminalSyncState(departureTerminalState)
  resetTerminalSyncState(destinationTerminalState)
}

export const decorators = [
  createDecorator({
    field: /cargo\[\d+].type/,
    updates: (value, name, allValues) => {
      let updates = {}
      const [fieldName] = name.split('.')
      const palletLength = get(allValues, `${fieldName}.palletLength`)
      const palletWidth = get(allValues, `${fieldName}.palletWidth`)

      if (value === OrderCargoServiceType.Id.PALLET) {
        if (!palletLength) {
          updates = {
            ...updates,
            [name.replace('type', 'palletLength')]: PALLET_LENGTH_IN_CENTIMETER
          }
        }

        if (!palletWidth) {
          updates = { ...updates, [name.replace('type', 'palletWidth')]: PALLET_MIN_WIDTH_IN_CENTIMETER }
        }
      }

      return updates
    }
  }) as Decorator<OrderGuestCreateFormData>,
  ...createTerminalSyncDecorators<OrderGuestCreateFormData>('departure', departureTerminalState),
  ...createTerminalSyncDecorators<OrderGuestCreateFormData>('destination', destinationTerminalState)
]
